import { OPEN_MODAL } from '@iwModals/Modals.actions';
import { Button } from '@iwoca/orion';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from '../RequestMoreFundsPanel.module.css';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    openHelpModal: () =>
        dispatch({
            type: OPEN_MODAL,
            id: 'HelpModal'
        })
});

type OwnProps = {
    heading: React.ReactNode;
    description?: React.ReactNode;
    ctaText?: React.ReactNode;
    trackEvent?: () => void;
};

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const TopUpStatusMessage = ({
    heading,
    description,
    ctaText,
    openHelpModal,
    trackEvent
}: OwnProps & PropsFromRedux) => {
    return (
        <div className={styles.topUpStatusContainer}>
            <div className={styles.textContainer}>
                <h2 className={styles.heading}>{heading}</h2>
                <p className={styles.description}>{description}</p>
                {ctaText && (
                    <Button
                        className={styles.cta}
                        onClick={() => {
                            if (trackEvent) trackEvent();
                            openHelpModal();
                        }}
                    >
                        {ctaText}
                    </Button>
                )}
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(TopUpStatusMessage);
